export const GENERIC = 'generic';
export const ADVISOR = 'advisor';
export const LEARN = 'learn';
export const HOME = 'home';
export const RETIREMENT_PLAN_INSIGHTS = 'retirement-plan-insights';
